<div class="loader-block">
    <div class="lds-hourglass"></div>
</div>
